export function getDateFormatInput(date: string | undefined) {
  return date?.split("/").reverse().join("-");
}

export function getDateFormatText(date: string | undefined) {
  return date?.substring(0, 10).split("-").reverse().join("/");
}

export function getDateTimeFormatText(date: string | undefined) {
  if (!date) return undefined;

  const parsed = new Date(date);

  if (Number.isNaN(parsed.getTime())) {
    return getDateFormatText(date);
  }

  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const year = parsed.getFullYear();
  const hours = String(parsed.getHours()).padStart(2, "0");
  const minutes = String(parsed.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} às ${hours}:${minutes}`;
}

export function bytesToMegaBytes(bytes: number) {
  return (bytes / 1024 ** 2).toFixed(2);
}
